import React from "react";
import { Grid, Paper, Box, Skeleton } from "@mui/material";

const DashboardCardSkeleton = () => {
  return (
    <Grid item xs={12} sm={6} md={3}>
      <Paper
        elevation={1}
        sx={{
          borderRadius: 2,
          p: 2,
          minHeight: 120,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          boxShadow: "none",
          border: "1px solid #E8E8E8",
        }}
      >
        {/* Title + Icon */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Skeleton variant="text" width="60%" height={18} />
          <Skeleton variant="circular" width={24} height={24} />
        </Box>

        {/* Main Value */}
        <Skeleton variant="text" width="40%" height={28} />

        {/* Sub Data (Document, Selfie, etc.) */}
        <Box sx={{ mt: 1 }}>
          <Skeleton variant="text" width="70%" height={16} />
          <Skeleton variant="text" width="50%" height={16} />
        </Box>

        {/* Trend Arrow/Percentage */}
        <Box sx={{ mt: 1 }}>
          <Skeleton variant="text" width="40%" height={16} />
        </Box>
      </Paper>
    </Grid>
  );
};

export default DashboardCardSkeleton;
